<script setup>
import {
    ExclamationIcon,
    XIcon,
    CheckCircleIcon,
    InformationCircleIcon,
    XCircleIcon,
} from "@heroicons/vue/outline";
import { ref, computed } from "vue";

import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

import { storeToRefs } from 'pinia'
const { confirms } = storeToRefs(errors)

const curConfirm = computed(() => {
	return confirms.value[confirms.value.length - 1] ?? null
});

const open = computed(() => {
	return confirms.value.length
});

const cancel = () => {
    errors.popConfirm()
};

const btnColor = computed(() => {
    if (curConfirm.value.type == "danger") {
        return "red";
    } else {
        return "blue";
    }
});
</script>

<template>
    <Transition
        enter-from-class="transition duration-300 opacity-0"
        enter-to-class="transition duration-300 opacity-100"
        leave-from-class="transition duration-300 opacity-100"
        leave-to-class="transition duration-300 opacity-0"
    >
        <div
            v-if="open"
            @click="cancel"
            class="
                flex
                fixed
                inset-0
                h-screen
                w-screen
                bg-black bg-opacity-30
                justify-center
                items-center
            "
        >
            <SectionCard class="max-w-[80%] lg:max-w-[65%]">
                <div class="flex">
                    <div
                        v-if="curConfirm.type === 'danger'"
                        class="
                            mx-auto
                            flex
                            h-12
                            w-12
                            bg-Red-50
                            flex-shrink-0
                            items-center
                            justify-center
                            rounded-full
                            sm:mx-0
                            sm:h-10
                            sm:w-10
                        "
                        :class="iconColor"
                    >
                        <ExclamationIcon
                            class="h-6 w-6 text-Red-600"
                            aria-hidden="true"
                        />
                    </div>
                    <div class="ml-4">
                        <h1
                            class="
                                mb-2
                                text-lg
                                font-medium
                                leading-6
                                text-gray-900
                            "
                        >
                            {{ curConfirm.title }}
                        </h1>
                        <p class="text-sm text-gray-500">{{ curConfirm.message }}</p>
                    </div>
                </div>
                <template #footer>
                    <Button
						data-testid="confirm-cancel-button"
                        :color="btnColor"
                        @click.prevent="cancel"
                        variant="link"
                        class="mr-2"
					>
						Cancel
					</Button>
                    <Button
						type="button"
						data-testid="confirm-confirm-button"
						:color="btnColor" 
						@click.prevent="curConfirm.onConfirm"
					>
						{{ curConfirm.btnText }}
					</Button>
                </template>
            </SectionCard>
        </div>
    </Transition>
</template>
